module.exports = __webpack_public_path__ + "static/img/NSW-7.e783dd4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/NSW-7.jpg
// module id = QTj+
// module chunks = 0